import { render, staticRenderFns } from "./GoodsSwimWearView2.vue?vue&type=template&id=73082505&"
import script from "./GoodsSwimWearView2.vue?vue&type=script&lang=js&"
export * from "./GoodsSwimWearView2.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSwimWearView2.vue?vue&type=style&index=0&id=73082505&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports